import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  isLoading: false,
  dashboards: [],
  dashboardEmployee: {
    isLoading: false,
    renvenueEmployee: [],
    error: null,
  },
  dashboardWarehouse: {
    isLoading: false,
    revenueWarehouse: {},
    error: null,
  },
  dashboardInternal: {
    isLoading: false,
    revenueInternal: {},
    error: null,
  },
  dashboardGrowth: {
    isLoading: false,
    growthRanking: [],
    // Starts false so the widget stays hidden until the API confirms access, rather
    // than flashing into view on first paint.
    canViewTable: false,
    canViewChart: false,
    // The eligibility threshold the server judged the ranking against — computed from
    // the month's own sales unless the viewer picked one.
    minSales: null,
    error: null,
  },
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET BLOG
    getDashboard(state, action) {
      state.isLoading = false;
      state.dashboards = action.payload;
    },

    startLoadingRenvenueEmployee(state) {
      state.dashboardEmployee.isLoading = true;
    },

    getRenvenueEmployee(state, action) {
      state.dashboardEmployee.isLoading = false;
      state.dashboardEmployee.renvenueEmployee = action.payload;
    },

    hasErrorRenvenueEmployee(state, action) {
      state.dashboardEmployee.isLoading = false;
      state.dashboardEmployee.error = action.payload;
    },

    startLoadingRevenueWarehouse(state) {
      state.dashboardWarehouse.isLoading = true;
    },

    getRevenueWarehouse(state, action) {
      state.dashboardWarehouse.isLoading = false;
      state.dashboardWarehouse.revenueWarehouse = action.payload;
    },

    hasErrorRevenueWarehouse(state, action) {
      state.dashboardWarehouse.isLoading = false;
      state.dashboardWarehouse.error = action.payload;
    },

    startLoadingRevenueInternal(state) {
      state.dashboardInternal.isLoading = true;
    },

    getRevenueInternal(state, action) {
      state.dashboardInternal.isLoading = false;
      state.dashboardInternal.revenueInternal = action.payload;
    },

    hasErrorRevenueInternal(state, action) {
      state.dashboardInternal.isLoading = false;
      state.dashboardInternal.error = action.payload;
    },

    startLoadingGrowthRanking(state) {
      state.dashboardGrowth.isLoading = true;
    },

    getGrowthRanking(state, action) {
      state.dashboardGrowth.isLoading = false;
      state.dashboardGrowth.growthRanking = action.payload.growthRanking;
      state.dashboardGrowth.canViewTable = action.payload.canViewTable;
      state.dashboardGrowth.canViewChart = action.payload.canViewChart;
      state.dashboardGrowth.minSales = action.payload.minSales;
    },

    hasErrorGrowthRanking(state, action) {
      state.dashboardGrowth.isLoading = false;
      state.dashboardGrowth.error = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getDashboard(queryParams) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('dashboard', { params: queryParams });
      const dashboard = response?.data?.data?.dashboards || [];

      let newBlogs = dashboard;
      if (newBlogs?.per_page) {
        newBlogs = newBlogs.data;
      }
      dispatch(slice.actions.getDashboard(newBlogs));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getRenvenueEmployee(queryData) {
  return async () => {
    dispatch(slice.actions.startLoadingRenvenueEmployee());
    try {
      const response = await axios.get('get-employee-sales', { params: queryData });
      const reports = response?.data?.data?.reports || [];
      let newReport = reports;
      if (newReport?.per_page) {
        newReport = newReport.data;
      }

      dispatch(slice.actions.getRenvenueEmployee(newReport));
    } catch (error) {
      dispatch(slice.actions.hasErrorRenvenueEmployee(error));
    }
  };
}

export function getRevenueWarehouse(queryData) {
  return async () => {
    dispatch(slice.actions.startLoadingRevenueWarehouse());
    try {
      const response = await axios.get('get-employee-admin', { params: queryData });
      const reports = response?.data?.data?.reports || [];
      let newReport = reports;
      if (newReport?.per_page) {
        newReport = newReport.data;
      }

      dispatch(slice.actions.getRevenueWarehouse(newReport));
    } catch (error) {
      dispatch(slice.actions.hasErrorRevenueWarehouse(error));
    }
  };
}

export function getRevenueInternal(queryData) {
  return async () => {
    dispatch(slice.actions.startLoadingRevenueInternal());
    try {
      const response = await axios.get('get-revenue-internal', { params: queryData });
      const { revenueInternal } = response?.data?.data;

      dispatch(slice.actions.getRevenueInternal(revenueInternal));
    } catch (error) {
      dispatch(slice.actions.hasErrorRevenueInternal(error));
    }
  };
}

export function getGrowthRanking(queryData) {
  return async () => {
    dispatch(slice.actions.startLoadingGrowthRanking());
    try {
      const response = await axios.get('get-growth-ranking', { params: queryData });

      dispatch(
        slice.actions.getGrowthRanking({
          growthRanking: response?.data?.data?.growthRanking || [],
          canViewTable: response?.data?.data?.canViewGrowthTable === true,
          canViewChart: response?.data?.data?.canViewGrowthChart === true,
          minSales: response?.data?.data?.minSales ?? null,
        })
      );
    } catch (error) {
      dispatch(slice.actions.hasErrorGrowthRanking(error));
    }
  };
}
